import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import ReactJsonViewer from 'react-json-view'

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('GENERIC_FILING_VALUES', LOG_LEVELS.DEBUG);

class FilingValuesForGenericReturns extends Component {
  render() {
    log.debug('render(): ', this.props);
    const lines = this.props.filingValues.lines || [{'No Values': ''}];
    const headers = Object.keys(lines[0]);
    log.debug('render(): headers', headers);
    log.debug('render(): lines', lines);

    return (
        <s-row>
          <s-col span="12">
            <h2><LanguageStringResolver string='filingValues_values'/></h2>
            <ReactJsonViewer
              src={this.props.filingValues}
              collapsed="2"
              collapseStringsAfterLength="15"
              groupArraysAfterLength="5"
              displayDataTypes="true"
              theme="shapeshifter:inverted"

            />
          </s-col>
        </s-row>
    );
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {

  return {
    languages: state.languages

  };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(FilingValuesForGenericReturns);
